export const PRODUCT_NAME = 'Budget';
export const PRODUCT_DESCRIPTION =
  'A local-first personal finance application that works offline.';
